// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3Hh10","errors":"Errors_errors__1Y6dw"};